export const homeObjOne = {
    id: 'sobrenosotros',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Origen',
    headline: 'Mercadeo y Publicidad',
    description: 'Nos encargamos de hacer crecer el alcance y la visión de tu marca, proyectando ideas y conceptos de manera creativa para su posicionamiento.',
    buttonLabel: 'Más información',
    imgStart: true,
    img: require('../../images/img1.png'),
    alt: 'Gestión de proyectos',
    dark: true,
    primary: false,
    darkText: false,
    Route: '/Nosotros'
};


export const homeObjTwo = {
    id: 'colaboraciones',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Emprendimientos',
    headline: 'Para cualquier línea de negocio',
    description: 'Sin importar cuál sea la principal línea de negocio de tu emprendimiento, Origen crea una identidad única y propia de reconocer.',
    buttonLabel: 'Colaboraciones',
    imgStart: false,
    img: require('../../images/img3.png'),
    alt: 'Impresión de marca',
    dark: false,
    primary: true,
    darkText: true,
    Route: '/Colaboraciones'
};

export const homeObjThree = {
    id: 'contacto',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Comunicación',
    headline: 'En cualquier lugar',
    description: 'Nos caracterizamos por satisfacer siempre al cliente y por darle un servicio de calidad sin importar los obstáculos geográficos.',
    buttonLabel: 'Comunícate',
    imgStart: true,
    img: require('../../images/img2.png'),
    alt: 'car',
    dark: false,
    primary: true,
    darkText: true,
    Route: '/Contacto'
};